import React from 'react';
import present from '@static/images/seo-landing/gift-banner-min.jpg';
import internet from '@static/images/seo-landing/int-banner-min.jpg';
import tv from '@static/images/seo-landing/tv-banner-min.jpg';
import tvinternet from '@static/images/seo-landing/tv-int.jpg';

import Card from './Card';

import * as ST from './styled';

const options = [
    {
        title: 'ТВ+интернет',
        description: 'Экономия до 40% ежемесячно.',
        link: 'Выбрать тариф',
        img: tvinternet,
        href: 'bundles',
    },
    {
        title: 'Телевидение в НD-качестве',
        description: 'Лидер по количеству HD-каналов в России.',
        link: 'Узнать о преимуществах',
        img: tv,
        href: 'domru-tv',
    },
    {
        title: 'Интернет',
        description: 'Домашний интернет со скоростью до 100 мбит/с.',
        link: 'Подключиться',
        img: internet,
        href: 'internet',
    },
    {
        title: 'Подарки для всех',
        description: 'На протяжении всего 2020 года.',
        link: 'Выбрать свой подарок',
        img: present,
        href: 'podarki',
    },
];

interface IServices {
    link: string,
    changeUrl: (url: string)=>void,
}

const Services = ({ link, changeUrl }:IServices) => {
    return (
        <ST.Service>
            <ST.Container>
                {options.map((item, index) => (
                    <Card key={index}
                        title={item.title}
                        description={item.description}
                        link={item.link}
                        href={link ? link + item.href : ''}
                        popupHref={item.href}
                        img={item.img}
                        changeUrl={changeUrl}
                    />
                ))}
            </ST.Container>
      </ST.Service>
    );
};

export default Services;
